import { Injectable } from '@angular/core';
import { PrinterClass } from './printer-class';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrinterClassService {

  classesApi = environment.apiPath + '/classes';

  constructor(private http: HttpClient) { }

  getPrinterClasses(): Observable<PrinterClass[]> {
    return this.http.get<PrinterClass[]>(this.classesApi);
  }

  createPrinterClass(printerClass: PrinterClass): Observable<PrinterClass> {
    console.log('Sending POST PrinterClass ' + printerClass);
    return this.http.post<PrinterClass>(this.classesApi, printerClass);
  }

  deletePrinterClass(printerClass: PrinterClass): Observable<PrinterClass> {
    console.log('Sending DELETE PrinterClass ' + printerClass);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: printerClass
    };
    return this.http.delete<PrinterClass>(this.classesApi, httpOptions);
  }
}
